import { css } from 'styled-components';

const variables = css`
  :root {
    --dark-navy: #0a1f19; /* Dark neutral background with slight green undertone */
    --navy: #12332a; /* Slightly lighter for sections and headers */
    --light-navy: #1a4b38; /* Cards or subtle highlights */
    --lightest-navy: #2a6047; /* Hover states or subtle borders */
    --navy-shadow: rgba(10, 31, 25, 0.7); /* Shadow matching dark-navy */
    --dark-slate: #4a6e57; /* Muted text on dark background */
    --slate: #7aa786; /* Main text on dark sections */
    --light-slate: #a2c4a1; /* Subtle highlights/text */
    --lightest-slate: #c4e0c3; /* Lighter text or accents */
    --white: #e6f1ff; /* Keep white for contrast */
    --green: #3fae8e; /* muted teal-green, softer than pure green */
    --green-tint: rgba(63, 174, 142, 0.15); /* soft background accent */
    --pink: #f57dff;
    --blue: #57cbff;

    --font-sans: 'Calibre', 'Inter', 'San Francisco', 'SF Pro Text', -apple-system, system-ui,
      sans-serif;
    --font-mono: 'SF Mono', 'Fira Code', 'Fira Mono', 'Roboto Mono', monospace;

    --fz-xxs: 12px;
    --fz-xs: 13px;
    --fz-sm: 14px;
    --fz-md: 16px;
    --fz-lg: 18px;
    --fz-xl: 20px;
    --fz-xxl: 22px;
    --fz-heading: 32px;

    --border-radius: 4px;
    --nav-height: 100px;
    --nav-scroll-height: 70px;

    --tab-height: 42px;
    --tab-width: 120px;

    --easing: cubic-bezier(0.645, 0.045, 0.355, 1);
    --transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);

    --hamburger-width: 30px;

    --ham-before: top 0.1s ease-in 0.25s, opacity 0.1s ease-in;
    --ham-before-active: top 0.1s ease-out, opacity 0.1s ease-out 0.12s;
    --ham-after: bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    --ham-after-active: bottom 0.1s ease-out,
      transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;
  }
`;

export default variables;
